import { IdType } from "../Utils/IdType";

export type QueryKeyName =
  | "bidPacks"
  | "carriers"
  | "contacts"
  | "edcs"
  | "odcs"
  | "pdsrs"
  | "plants"
  | "rateAgreements"
  | "spdrs"
  | "suppliers"
  | "ttProtections";

export const namedQueryKeyWithId = (queryKeyName: QueryKeyName, id: IdType) =>
  typeof id === "number" ? [queryKeyName, id.toString()] : [queryKeyName, id];

export const namedQueryKey = (queryKeyName: QueryKeyName) => [queryKeyName];
